import EmployeeInfoEducationComponent from "../components/EmployeeInfoEducation";
import useEmployeeEducation from "../hooks/useEmployeeEducation";

function EmployeeInfoEducation(props) {
  const useEmployeeEducationProps = useEmployeeEducation();
  return <EmployeeInfoEducationComponent {...useEmployeeEducationProps} {...props} />;
}

export default EmployeeInfoEducation;
